import { GetResponseType } from '@/api/types/api';
import { ApiResponseDefinition } from '@/api/types/api-definition';
import ImageNav from './ImageNav';
import LensProcessNav from './LensProcessNav';
import styles from './index.module.scss';
import TextNav from './TextNav';

interface SideNavDropdownProps {
  navData: GetResponseType<ApiResponseDefinition['GET:/api/nav/lists']>;
  isDarkMode: boolean;
  activeTabIndex: number;
  showDropdown: boolean;
  onDropdownMouseEnter: () => void;
  onDropdownMouseLeave: () => void;
}

const SideNavDropdown = ({
  navData,
  isDarkMode,
  activeTabIndex,
  showDropdown,
  onDropdownMouseEnter,
  onDropdownMouseLeave,
}: SideNavDropdownProps) => {
  return (
    <>
      {navData.map((navItem, index) => {
        if (!navItem.children || navItem.children.length === 0) return null;

        const isActive = showDropdown && activeTabIndex === index;

        const textNavItems = navItem.children.filter((item) =>
          [2, 4].includes(item.template_id || 0),
        );
        const imageNavItems = navItem.children.filter((item) => item.template_id === 3);

        return (
          <div
            key={`dropdown-${navItem.id}`}
            className={`absolute left-[0] top-[60px] z-[202] w-screen ${isDarkMode ? 'bg-[#131415]' : 'bg-white'} flex justify-between items-start px-[48px] box-border shadow-md`}
            style={{
              boxShadow: '0px 4px 12px 0px rgba(0,0,0,0.08)',
              display: isActive ? 'flex' : 'none',
            }}
            onMouseEnter={onDropdownMouseEnter}
            onMouseLeave={onDropdownMouseLeave}
          >
            <div className="flex-shrink-0 flex gap-[40px] xl:gap-[100px]">
              {textNavItems.map((item, idx) => {
                if (item.template_id === 2) {
                  return (
                    <div key={`${item.id}-${item.template_id}`} className="flex-shrink-0">
                      <TextNav
                        item={item}
                        firstLevelIndex={index}
                        firstLevelTitle={navItem.content?.nav_name || ''}
                        secondLevelIndex={idx}
                        isLast={idx === textNavItems.length - 1}
                        isDarkMode={isDarkMode}
                      />
                    </div>
                  );
                }
                if (item.template_id === 4) {
                  return (
                    <div key={`${item.id}-${item.template_id}`} className="flex-shrink-0">
                      <LensProcessNav isDarkMode={isDarkMode} />
                    </div>
                  );
                }
                return null;
              })}
            </div>

            <div className={`flex-shrink-1 flex ${styles.dropdownRightContainer}`}>
              {imageNavItems.map((item) => (
                <ImageNav
                  key={`${item.id}-${item.template_id}`}
                  item={item}
                  firstLevelIndex={index}
                  firstLevelTitle={navItem.content?.nav_name || ''}
                  isDarkMode={isDarkMode}
                />
              ))}
            </div>
          </div>
        );
      })}
    </>
  );
};

export default SideNavDropdown;
